/**
* Created For:500错误页 全屏弹窗
* Author: chenLiYan.
* Date: 2018/6/25 14:00.
*/
<template>
  <cube-popup type="server-error" :mask="false" position="top" ref="popup" class="server-error-popup">
    <div class="error-page">
      <div class="server-error"></div>
      <p class="error-text">呀，网络出了问题，请稍后重试！</p>
      <button type="button" class="act-btn" @click="refresh()">刷新试试</button>
    </div>
  </cube-popup>
</template>
<script type="text/ecmascript-6">
export default {
  name: 'ServerError',
  props: {
    isShow: { // 是否默认显示
      type: Boolean,
      default () {
        return true
      }
    }
  },
  mounted () {
    if (this.isShow) { this.$refs.popup.show() }
  },
  methods: {
    show () {
      this.$refs.popup.show()
    },
    hide () {
      this.$refs.popup.hide()
      this.$emit('hide')
    },
    refresh () {
      window.location.reload()
    }
  }
}
</script>
<style scoped lang="stylus">
    @import "../stylus/error.styl"
    .server-error-popup{
        background #fff
    }
</style>
